import * as angular from 'angular';
import { Observable } from 'rxjs';
import { UserResourceTypes } from '@mode/shared/contract-common';

class ReportDetailsTitleController {
  createdAt: string;
  displayName$: Observable<string>;
  description$: Observable<string>;
  lastSuccessfullyRunAt$: Observable<Date>;
  parentReportName: string;
  parentReportLink: string;
  createdAtDate: string;
  creator: UserResourceTypes.UserResource;
}

export const ID = 'reportDetailsTitle';

export const reportDetailsTitle: angular.IComponentOptions = {
  bindings: {
    parentReportName: '<',
    parentReportLink: '<',
    hasPublished: '<',
    createdAt: '<',
    description: '<',
    displayName: '<',
    lastRunAt: '<',
    creator: '<',
  },
  controller: ReportDetailsTitleController,
  controllerAs: 'ctrl',
  template: `
    <div class="layout-title">
      <div class="report-detail-title">
        <span>{{ ctrl.displayName }}</span>
      </div>
      <div class="published-info">
        <div class="published">
          {{ctrl.hasPublished ? "Published" : "Created"}} <mode-date-time-display [timestamp]="ctrl.createdAt"></mode-date-time-display>
          · Refreshed <mode-date-time-display [timestamp]="ctrl.lastRunAt"></mode-date-time-display>
        </div>
      </div>
      <div class="font-note" ng-if="ctrl.parentReportLink">
        Cloned from
        <a target="_self" ng-href="{{ctrl.parentReportLink}}">
          {{ ctrl.parentReportName }}
        </a>
      </div>
    </div>

    <report-details-creator creator="ctrl.creator"></report-details-creator>

    <div class="layout-section" ng-if="ctrl.description">
      <div class="details-title font-subtitle">Description</div>
      <div class="description">
        <p>{{ ctrl.description }}</p>
      </div>
    </div>
  `,
};
